import { DateTime } from 'luxon';

import useLocale from '../../Hooks/use-locale';
import { TimeslotButton, TimeslotWrapper, VacancyLabel, VancancyWrapper } from './style';
import useTypeSafeLocalize from '../../Hooks/use-type-safe-localize';
import { LocalizationCategory, ProductLocalization } from '../../localizations/types';
import { ParsedTimeslot } from './timeslots';

export interface TimeslotProps {
  timeslot: ParsedTimeslot;
  selected: boolean;
  warning: boolean;
  disabled: boolean;
  onChange: (timeslot: ParsedTimeslot) => void;
  localizedTimeFormat: boolean;
}

const Timeslot = (props: TimeslotProps) => {
  const { timeslot, selected, warning, disabled, onChange, localizedTimeFormat } = props;
  const localize = useTypeSafeLocalize();
  const { locale } = useLocale();

  const formatTimestamp = (dateTime: DateTime) => {
    return localizedTimeFormat
      ? dateTime.setLocale(locale).toLocaleString(DateTime.TIME_SIMPLE)
      : dateTime.toFormat('HH:mm');
  };

  return (
    <TimeslotWrapper>
      <VancancyWrapper warning={warning} onClick={() => onChange(timeslot)}>
        {warning && (
          <VacancyLabel>
            {timeslot.vacancies}{' '}
            {localize(LocalizationCategory.product, ProductLocalization.left)}
          </VacancyLabel>
        )}

        <TimeslotButton
          selected={selected}
          disabled={disabled}
          warning={warning}
          localized={localizedTimeFormat}
        >
          {formatTimestamp(timeslot.startTime)}
        </TimeslotButton>
      </VancancyWrapper>
    </TimeslotWrapper>
  );
};

export default Timeslot;
